const constraints = {
  username: {
    presence: {
      allowEmpty: false,
      message: 'is Required',
    },
  },
  password: {
    presence: {
      allowEmpty: false,
      message: 'is Required',
    },
  },
};

export default constraints;
